module.exports = __webpack_public_path__ + "img/1-images-tt.de0365b1.png";